<template>
    <div @click="showSetting">
        <div id="top">
			<div class="w">
				<div class="left c8" style="color: #888;">
					<a href="/" class="c9" style="color: #888;">
						<em class="f mt1"><i class="iconfont icon-home2" style="color: #888;"></i></em>首页
					</a>
					<span class="vline">|</span>
					<span v-if="name == ''">
						<a rel="nofollow" href="javascript:;" class="c9" @click="login()" style="color: #888;">{{name}}请登录</a>
						<span class="vline">|</span>
						<a rel="nofollow" href="javascript:;" class="c9" @click="register()" style="color: #888;">注册<em class="c9 pl10"></em></a>
					</span>
					<span v-else>
						<a rel="nofollow" href="javascript:;" class="c9" style="color: #888;">您好：{{name}}</a>
						<span class="vline">|</span>
						<a rel="nofollow" href="javascript:;" class="c9" @click="quit" style="color: #888;">退出<em class="c9 pl10"></em></a>
					</span>
					
				</div>
				<ul id="tul" class="tul right">
					<li>
						<a rel="nofollow" href="javascript:;" @click="$router.push({path: '/user_order'})">
							查询订单
						</a>
					</li>
					<li><span class="vline">|</span></li>
					<li class="nbt" @mouseleave="onMouseOutMember($event)" @mouseenter="onMouseOverMember($event)">
						<a rel="nofollow" href="javascript:;" @click="user">
							会员中心<em class="rdop"></em>
						</a>
						<div class="tuln" :style="activeMember">
							<a rel="nofollow" href="javascript:;" @click="$router.push({path: '/user_order'})">我的订单</a>
							<a rel="nofollow" href="javascript:;" @click="$router.push({path: '/user_fav'})">我的收藏</a>
							<a rel="nofollow" href="javascript:;" @click="$router.push({path: '/user_coupon'})">我的优惠券</a>
							<a rel="nofollow" href="javascript:;" @click="$router.push({path: '/user_address'})">收货地址</a>
						</div>
					</li>
					<li><span class="vline">|</span></li>
					<li class="nbt" @mouseleave="onMousePhoneOut($event)" @mouseenter="onMousePhoneOver($event)">
						<a rel="nofollow" href="javascript:;">
							<em class="f mt1"><i class="iconfont icon-shouji1"></i></em>手机版<em class="rdop"></em>
						</a>
						<div class="tuln" :style="activeCode">
							<img src="../../assets/image/minapp_qw.jpg" width="124" height="141">
						</div>
					</li>
					<li><span class="vline">|</span></li>
					<li class="nbt" @mouseleave="onMouseOutHelp($event)" @mouseenter="onMouseOverHelp($event)">
						<a rel="nofollow" href="javascript:;" @click="help">
							帮助中心<em class="rdop"></em>
						</a>
						<div class="tuln" :style="activeHelp">
							<a rel="nofollow" href="/help/fangshi">如何订购</a>
							<a rel="nofollow" href="/help/huodaofukuan">货到付款</a>
							<a rel="nofollow" href="/help/zaixian">在线支付</a>
							<a rel="nofollow" href="/help/dianhuadinggou">电话订购</a>
							<a rel="nofollow" href="/help/kefu">客服中心</a>
						</div>
					</li>
				</ul>
				<div class="clear"></div>
			</div>
		</div>
		<div id="header">
			<div class="w">
				<div class="rel left">
					<a href="/" title="夜樱情趣,百变情趣,乐享生活" class="logo" rel="nofollow">
						<img src="../../assets/image/logo.png">
					</a>
					<p class="chead"></p>
				</div>
				<div id="search" class="search left" @click="settingEvent($event)">
					<div class="ov">
						<input type="text" id="keywords" name="keywords" v-model="keywords" class="shl left" placeholder="想买什么，搜一搜，如避孕套" onfocus ="if(placeholder=='想买什么，搜一搜，如飞机杯') {placeholder=''}" onblur ="if (placeholder=='') {placeholder='想买什么，搜一搜，如避孕套'}" @click="tanchukuang()" @keyup.enter.prevent="searchEnterFun($event)">
						<button type="submit" class="left shr" @click="search(keywords)">搜索</button>
					</div>
					<div id="rec_results" class="g-rec-results" v-show="msgShow">
						<ul class="history-results">
							<li class="title gray"><span>搜索历史</span></li>
							<li class="history" v-for="(history,index) in history" :key="index">
                                <router-link :to="{path:'/shop/shopsearch', query:{cate_id:it.id,showVideo:1,title:history}}" target="_blank">
                                    <p class="lmap">{{history}}</p>
                                </router-link>
								<a tabindex="-1" target="_blank" href="">飞机杯</a>
							</li>
						</ul>
						<ul class="rec-results">
							<li class="title gray">
								<span>精选推荐</span>
							</li>
							<li>
								<a tabindex="-1" target="_blank" href="">飞机杯</a>
							</li>
							<li>
								<a tabindex="-1" target="_blank" href="">女优娃娃</a>
							</li>
						</ul>
					</div>
					<div class="clear"></div>
					<p class="hotw" style="margin-top: 5px;">
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=13'}" target="_blank">
								仿真阳具
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=10'}" target="_blank">
								阴臀倒模
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=22'}" target="_blank">
								外用延时
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=14'}" target="_blank">
								震动棒
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=6'}" target="_blank">
								飞机杯
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=33'}" target="_blank">
								阴蒂刺激
							</router-link>
						</span>
					</p>
					<div id="s_box"></div>
				</div>
				<div class="tr_c right" id="tcar" @mouseleave="onMouseOutCar($event)" @mouseenter="onMouseOverCar($event)">
					<a class="t_c" rel="nofollow"  @click="buycar">
						购物车
						<p id="qcar">{{number}}</p>
						<i class="ci_r">&gt;</i>
					</a>
					<div id="acar" style="z-index:99">
						<div class="ac_t alR" v-if="list == 0">您的购物车是空的,赶紧选购吧！</div>
						<div v-else>
							<ul class="acar">
								<li v-for="(item,index) in list.slice(0,3)" :key="index">
									<router-link :to="{path:'/detail', query:{id:item.pro.id}}"  target="_blank">
										<img :src="item.pro.piclink" width="60" height="60" class="left">
										<p>{{item.pro.title}}</p>
										<p class="mt5">¥{{$fnc.toFixedZ(item.pro.price)}} x {{item.number}}</p>
									</router-link>
								</li>
							</ul>
							<div class="ac_t">
								<a href="javascript:;" @click="buycar" class="srbtn mt5">
									<b class="f"></b> 去购物车结算
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="clear"></div>
			</div>
		</div>
        <div class="navq hnavq" id="nav">
            <div class="w">
                <div class="lcat" @mouseenter="onMouseEnter($event)" @mouseleave="onMouseLeave($event)">
                    <a href="javascript:;" class="nall">全部商品分类</a>
                    <ul class="lnav active" id="lnav" :style="active">
                        <li v-for="(item,index) in cate" :key="item.id"   @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
                            <div style="line-height: 38px;">
                                <em class="f"><i :class="item.icon" style="font-size:20px;"></i></em>
                                <div>
                                    <a class="lma" href="javascript:;" @click="catesearch(item.title,index)" >{{item.title}}</a>
                                    <div>
                                        <div v-for="(it,its) in item.z.slice(0,3)" :key="it.id"  style="float:left;padding-left:10px;">
                                            <router-link :to="{path:'/shop/shopsearch', query:{cate_id:it.id}}" target="_blank">
                                                <p class="lmap">{{it.title}}</p>
                                            </router-link>
                                            <span class="sss" style="padding:0 6px;" v-if="its == 0 && its == 1">/</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="lra"  v-show="isActive || n != index">
                                <div class="lh3">
                                    <b class="left">{{item.title}}</b>
                                </div>
                                <div class="bo_icn over">
                                    <div v-for="it in item.z" :key="it.id">
                                        <router-link :to="{path:'/shop/shopsearch', query:{cate_id:it.id}}" target="_blank" class="b_aa">
                                            <img width="45" height="45" class="c_img" :src="it.piclink">
                                            <p>{{it.title}}</p>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <pc-top-menu></pc-top-menu>
                <div class="clear"></div>
            </div>
        </div>
        <pc-right-side></pc-right-side>
        
    </div>
</template>

<script>
//引入公共方法
// import { setCookie,getCookie,delCookie } from '../../assets/js/cookie.js'
import Topmenu from "@/components/common/top-menu"
import Pc_right_side from "@/components/common/right-side.vue"
import Pc_aaa from "@/components/common/aaa.vue"
export default{
    components:{
		'pc-top-menu': Topmenu,
		'pc-right-side': Pc_right_side,
        'pc-aaa': Pc_aaa,
	},
    data(){
        return{
            number:"",
            activeMember:"",
			activeHelp:"",
            activeCode:"",
            n: 999,
            active:"",
            cate:[],
            type: 1,
            isActive: false,
            icon : [
                {icon:"iconfont icon-nanxing"},
                {icon:"iconfont icon-nvxing"},
                {icon:"iconfont icon-nvyongqiju-tiaodan"},
                {icon:"iconfont icon-diaodai"},
                {icon:"iconfont icon-tehui"},
                {icon:"iconfont icon-anquantaobiyuntao"},
            ],
            name:"",
			msgShow:false,
            keywords:"",
            history:[],
            list:"",
        }
    },
    mounted() {
        this.getShopCate();
        // this.getHistory();
        this.cartList();
        /*页面挂载获取保存的localStorage值，渲染到页面上*/
        if(window.localStorage.getItem("user")){
            this.name = JSON.parse(window.localStorage.getItem("user")).nickname
        }
		
    },
    methods:{
        //回车事件搜索
		 searchEnterFun (e){
			var keyCode = window.event ? e.keyCode : e.which;
			if(this.keywords != ""){
				if (keyCode == 13) {
					this.search(this.keywords)
				}
			}else{
                this.$confirm('请输入要搜索的关键字', '提示', {
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning' // 提示类型  success/info/warning/error
		        })
            }
		},

        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.cate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            item.icon=this.icon[index].icon
                            this.cate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取搜索历史
        getHistory() {
            this.$api.getShop.getHistory({}).then(res => {
                if (res.code == 200) {
                    this.history = res.result;
                    var Storage = window.sessionStorage; 
                    Storage.setItem("search", JSON.stringify(this.history))
                }
            });
        },
		catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 5){
                this.$router.push(`/biyuntao/`);
            }else if(index == 2){
                this.$router.push(`/zhuxing/`);
            }else if(index == 3){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 4){
                this.$router.push(`/tehui/`);
            }
        },
        onMouseEnter(){
            this.active="display:block;"
        },
        onMouseLeave(){
            this.active="display:none;"
        },
        onMouseOver($event){
            $event.currentTarget.className="con";
            this.activeCode = false;
        },
        onMouseOut($event){
            $event.currentTarget.className="";
            this.activeCode = true;
        },
        onMousePhoneOver($event){
            $event.currentTarget.className="nbt on";
            this.activeCode = false;
        },
        onMousePhoneOut($event){
            $event.currentTarget.className="nbt";
            this.activeCode = true;
        },
        onMouseOverCar($event){
            $event.currentTarget.className="tr_c right hv";
        },
        onMouseOutCar($event){
            $event.currentTarget.className="tr_c right";
        },
        login(){
            //指定跳转地址
            this.$router.push('/login')
        },
        register(){
            //指定跳转地址
            this.$router.push('/login')
        },
        safes(){
            //指定跳转地址
            this.$router.push('/safes')
        },
        jiameng(){
            //指定跳转地址
            this.$router.push('/jiameng')
        },
        search(keywords){
			var params = {};
            params.keywords = keywords || "";
			//指定跳转地址
			this.$router.push({path:'/search',query:{keywords:params.keywords,showVideo:1}});
            this.$router.go(0)
		},
		buycar(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/car')
			}else{
				this.$router.push('/login')
			}
		},
		user(){
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_infor')
			}else{
				this.$router.push('/login')
			}
		},
		help(){
			//指定跳转地址
			this.$router.push('/help')
		},
		quit(){
			/*删除cookie*/
			localStorage.clear();
            this.$router.push({name:"Login"})
		},
        
		onMouseOverCode($event){
            $event.currentTarget.className="nbt on";
            this.active = false;
        },
        onMouseOutCode($event){
            $event.currentTarget.className="nbt";
            this.active = true;
        },
        onMouseOverMember($event){
            $event.currentTarget.className="nbt on";
            this.activeMember = false;
        },
        onMouseOutMember($event){
            $event.currentTarget.className="nbt";
            this.activeMember = true;
        },
		onMouseOverHelp($event){
            $event.currentTarget.className="nbt on";
            this.activeHelp = false;
        },
        onMouseOutHelp($event){
            $event.currentTarget.className="nbt";
            this.activeHelp = true;
        },
		tanchukuang(){
            // this.activeT="display:block;"
			this.msgShow = true;
        },
		showSetting(){
			this.$set(this, 'msgShow', false);
			//全局区域内点击时showSettingCon均为false
		},
		settingEvent(event){
			event.stopPropagation(); //此区域不受上面方法的影响
		},
		clickSetting(){
			this.$set(this, 'msgShow', !this.showSettingCon)
			//事件触发时showSettingCon显示隐藏状态互换
		},
        //购物车
		cartList(){
            var cart_params = {};
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.getCartList(cart_params).then(res => {
                if (res.code == 200) {
                    this.list = [];
                    if(res.result[0].all_price == ""){
                        this.number = 0;
                    }else{
                        this.number = res.result[0].data.length;
						var arr = res.result[0].data;
						arr.forEach((item,i) => {
							this.list.push(item);
						});
                    }
                }
            });
        },
    }
}
</script>

<style scoped>
.active{display: none;}
.hide {
    display: none;
}
.g-rec-results {
    width: 492px;
}
.g-rec-results {
    position: absolute;
    left: 0;
    width: 492px;
    height: 269px;
    border: 1px solid #e4e4e4;
    background: #FFF;
    z-index: 7000;
    overflow: hidden;
}
.g-rec-results ul.history-results {
    width: 200px;
}

.g-rec-results ul.history-results {
    float: left;
    width: 200px;
    height: 269px;
    border-right: 1px solid #efefef;
}
.g-rec-results ul {
    list-style-position: outside;
    list-style: none;
    padding: 0;
    margin: 0;
}
.g-rec-results ul.history-results li.title.gray {
    padding: 10px 0 0 15px;
}
.g-rec-results ul.history-results li.title {
    padding: 0 10px;
    color: #999;
    line-height: 28px;
	margin: 0 0 7px 0;
	float: none;
    position: relative;
}
.g-rec-results li {
    margin: 0;
    cursor: default;
    line-height: 24px;
    text-align: left;
    color: #666;
    overflow: hidden;
}
.g-rec-results ul.history-results .search-express-none {
    display: block;
    width: 160px;
    height: 136px;
    margin: 40px auto;
    background: url(../../assets/picture/search-express-none.png);
}
.g-rec-results ul.rec-results li.title{
    float: none;
    position: relative;
    padding: 10px 0 0 15px;
    margin: 0 0 7px 0;
    border: 0;
    color: #999;
    line-height: 28px;
}
.g-rec-results ul.rec-results li{
    float: left;
    position: relative;
    height: 26px;
    margin: 0 0 15px 15px;
    overflow: hidden;
}
.g-rec-results li {
    margin: 0;
    cursor: default;
    line-height: 24px;
    text-align: left;
    color: #666;
    overflow: hidden;
}
.g-rec-results ul.rec-results li a.high-light{
    border-color: #F60;
    _border-color: #e1e1e1;
    color: #F60;
    text-decoration: none;
}
.g-rec-results ul.rec-results li a{
    display: block;
    padding: 0 5px;
    border: 1px solid #e1e1e1;
    color: #666;
    white-space: nowrap;
}
.g-rec-results ul.rec-results li a.high-light:hover {
    color: #FFF;
}
.g-rec-results ul.rec-results li a:hover {
    border-color: #F60;
    color: #FFF;
    background: #F60;
    text-decoration: none;
}
.g-rec-results li.history{
	float: left;
    position: relative;
    height: 26px;
    margin: 0 0 15px 15px;
    overflow: hidden;
    cursor: default;
    line-height: 24px;
    color: #666;
    overflow: hidden;
}
.history a {
	display: block;
    padding: 0 5px;
    border: 1px solid #e1e1e1;
    color: #666;
    white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/components/common/public-top.vue